import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('commissions.taxes.routes.index'),
        name: i18n.t('commissions.taxes.routes.index'),
        component: () =>
            import(
                /* webpackChunkName: "commissions.taxes" */ '@/views/commissions/taxes/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('commissions.taxes.breadcrumbs.index'),
                    to: {
                        name: i18n.t('commissions.taxes.routes.index'),
                    },
                    disable: true,
                },
            ],
        },
    },
]
